import GenericLogo from '@nv/images/logos/generic/generic-logo'
import GenericLogoCollapsed from '@nv/images/logos/generic/generic-logo-collapsed'

export const fnTheme = {
  bgColor: 'var(--color-white)',
  textColor: 'var(--color-black)',
  logos: { en: GenericLogo },
  MobileLogo: GenericLogoCollapsed,
}
